var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditSquare = function SvgEditSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M158.511 965.582q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h405l-60 60h-345v600h600v-348l60-60v408q0 24-18 42t-42 18zm482-712 43 42-285 284v86h85l286-286 42 42-303 304h-170v-170zm171 168-171-168 100-100q17-17 42.311-17t42.69 18l84 85q17 18 17 42.472t-18 41.528z"
  })));
};
export default SvgEditSquare;